<app-modal>
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading">
    <app-modal-header
      [title]="T.common.add_item | translate: { item: localisedJob }"
      [showDelete]="false"
      (closed)="closeModal()">
    </app-modal-header>

    <app-modal-body>
      <div class="overflow-hidden" [formGroup]="jobForm">
        <section class="row col-row-space custom-gutters section-padding">
          <div class="col-12">
            <app-text-field
              [placeholder]="(T.common.item_title | translate: { item: localisedJob }) + '*'"
              [displayError]="triggerIndicatorErrors"
              formControlName="title"
              [formGroup]="jobForm"
              [maxLength]="250"
              [required]="true"
              [useReactiveMessages]="true"
              [autofocus]="true"
              [required]="true"
              [disableMargin]="true"
              name="title">
            </app-text-field>
          </div>
          <div class="col-12 col-lg-8">
            <app-filter-dropdown-new
              class="modal-project"
              [displayError]="triggerIndicatorErrors"
              [filterByModuleObjectType]="false"
              [filterType]="filterTypes.Job_Type"
              [disableMargin]="true"
              [required]="true"
              [disabled]="false"
              [singleSelect]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [currentlySelectedSettingValue]="selectedJobType?.filterValue"
              (onFilterUpdate)="handleJobTypeChange($event)" [label]="(T.common.type.one | translate) + '*'">
            </app-filter-dropdown-new>
          </div>
          <div class="col-12 col-lg-4">
            <app-simple-dropdown
              #searchDropdown
              [objects]="jobStatuses"
              [bindProperty]="'value'"
              [label]="T.common.status.one | translate"
              [currentlySelectedObject]="jobStatus"
              (objectSelected)="onJobStatusSelected($event)">
            </app-simple-dropdown>
          </div>
          <div class="col-12">
            <app-filter-dropdown-new
              [filterByModuleObjectType]="false"
              [disabled]="!selectedJobType"
              class="flex-fill modal-taskgroup"
              [filterType]="filterTypes.Job_Category"
              [disableMargin]="true"
              [singleSelect]="true"
              [required]="true"
              [appliedFilters]="filters"
              [typeahead]="true"
              [singleSelect]="true"
              [label]="(T.common.category.one | translate) + '*'"
              [currentlySelectedSettingValue]="selectedJobCategory?.filterValue"
              (onFilterUpdate)="handleFilterChange($event, filterTypes.Job_Category)"
              [relatedObjectId]="selectedJobType?.filterValue">
            </app-filter-dropdown-new>
          </div>
          <div class="col-12">
            <app-text-field
              name="headlineStatus"
              [formGroup]="jobForm"
              [placeholder]="T.defaultLocalizations.headline_status.one | translate"
              [maxLength]="255"
              [minLength]="3"
              [displayError]="triggerIndicatorErrors"
              formControlName="headlineStatus"
              [required]="false"
              [useReactiveMessages]="true">
            </app-text-field>
          </div>
          <div class="col-12">
            <app-details-editable-field
              [input]="job.description ? job.description : ''"
              [header]="T.defaultLocalizations.description.one | translate"
              [type]="editableFieldTypes.RichText"
              [canEdit]="true"
              (onUpdate)="onDescriptionChange($event)"
              [placeholder]="T.common.add_description | translate"
              name="description"
              (onInputChange)="onDescriptionChange($event)"
              (isInvalid)="isDescriptionInvalid($event)">
            </app-details-editable-field>
          </div>

          <div *ngIf="isCalledFromPIR && copiedEventFilter" class="checkbox-wrapper col-12">
            <app-checkbox
              [isChecked]="copyEventFromPIR"
              (checked)="copyEventFromPIR = $event"
            >
            </app-checkbox>
            <span>{{ T.common.copy_event_from_incoming_report | translate }}</span>
          </div>
        </section>
        <app-accordion-details [collapsing]="false" [emphasizedHeaders]="true">
          <app-accordion-item-details [title]="T.common.assign | translate" [expanded]="false">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12 qa-incident-endTime">
                  <app-optional-date-time
                    [firstDateString]="jobStartTime"
                    [secondDateString]="jobEndTime"
                    [showPickers]="false"
                    [editMode]="true"
                    [showCheckbox]="false"
                    (onFirstDateChanged)="onStartDateChanged($event)"
                    (onSecondDateChanged)="onEndDateChanged($event)">
                  </app-optional-date-time>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Owner"
                    [appliedFilters]="filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.common.assign_owner.many | translate"
                    (onFilterUpdate)="handleFilterChange($event)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex">
                    <app-button-transparent size="small" icon="add" text="Assign Me" (clicked)="addCurrentUserAsOwner()">
                    </app-button-transparent>
                  </div>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.External_User"
                    [appliedFilters]="filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [singleSelect]="true"
                    [currentlySelectedSettingValue]="currentlySelectedExternalUser?.filterValue"
                    [label]="T.settings.employees_departments_org.external_user | translate"
                    (onFilterUpdate)="handleFilterChange($event, filterTypes.External_User)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex">
                  <app-button-transparent
                    size="small"
                    icon="add"
                    [text]="T.settings.employees_departments_org.add_new_external_user | translate"
                    (clicked)="addNewExternalUser()">
                  </app-button-transparent>
                  </div>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new
                    [filterType]="filterTypes.Department"
                    [appliedFilters]="filters"
                    [disableMargin]="true"
                    [typeahead]="true"
                    [label]="T.common.assign_item | translate: { item: localisedDepartments }"
                    (onFilterUpdate)="handleFilterChange($event)">
                  </app-filter-dropdown-new>
                  <div class="bottom-element d-flex">
                    <app-button-transparent size="small" icon="add"
                      [text]="T.common.assign_my_localisedDepartment | translate: { localisedDepartment: localisedDepartment }"
                      (clicked)="addCurrentUserDepartment()"></app-button-transparent>
                  </div>
                </div>

                <div class="col-12 col-lg-6 job-privacy-status">
                  <app-simple-dropdown
                    [objects]="localisedPrivacyStatuses"
                    [currentlySelectedObject]="privacyStatus"
                    [bindProperty]="'value'"
                    [label]="T.defaultLocalizations.privacy_status.one | translate"
                    (objectSelected)="onPrivacyStatusSelected($event)">
                  </app-simple-dropdown>
                </div>
                <div class="col-12 col-lg-6 job-priority" [class.mobile]="isMobile">
                  <app-priority
                    [selectedPriority]="currentSelectedPriorityFilter"
                    (priorityChanged)="onApply($event)"
                    [showSelectPriorityLabel]="true"
                    [filterType]="filterTypes.Job_Priority">
                  </app-priority>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
          <app-accordion-item-details [title]="T.common.location.one | translate" [expanded]="false">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12">
                  <app-filter-dropdown-new [label]="localisedZone" [filterType]="filterTypes.Zone"
                    [filterByModuleObjectType]="false" [appliedFilters]="filters" [typeahead]="true"
                    (onFilterUpdate)="handleFilterChange($event)">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-filter-dropdown-new [label]="localisedArea" [filterType]="filterTypes.Area"
                    [filterByModuleObjectType]="false" [appliedFilters]="filters" [typeahead]="true" [usePredefinedFilters]="true"
                    [predefinedFilters]="applicableAreaFilters" [relatedObjectId]="selectedZone?.filterValue"
                    [disabled]="applicableAreaFilters.length === 0" (onFilterUpdate)="handleFilterChange($event)">
                  </app-filter-dropdown-new>
                </div>
                <div class="col-12">
                  <app-incident-map
                    [defaultZoom]="20"
                    [lat]="job.latitude"
                    [lng]="job.longitude"
                    [selectedZones]="mapZones"
                    [selectedAreas]="mapAreas"
                    [showIncidentZonesUponLoad]="true"
                    [editMode]="true"
                    (onLocationUpdated)="onJobLocationUpdated($event)">
                  </app-incident-map>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
          <app-accordion-item-details [title]="T.defaultLocalizations.tag.many | translate" [expanded]="false">
            <ng-template accordionContent>
              <section class="row col-row-space custom-gutters section-padding">
                <div class="col-12">
                  <app-add-modal-tag-groups
                    [showTitle]="false"
                    [filters]="filters"
                    [layoutClasses]="'col-12'"
                    [tagGroupObjectType]="objectTypes.Job"
                    (onFiltersUpdated)="handleFilterChange($event)">
                  </app-add-modal-tag-groups>
                </div>
              </section>
            </ng-template>
          </app-accordion-item-details>
        </app-accordion-details>
      </div>
    </app-modal-body>

    <app-modal-footer>
      <app-button-rectangle [buttonTheme]="'white'" [class]="'button'" [fitToContainer]="true" [size]="'large'"
        [text]="T.common.cancel | translate" (clicked)="closeModal()"></app-button-rectangle>
      <app-button-rectangle [disabled]="validateState()" [class]="'button'" [fitToContainer]="true" [size]="'large'"
        [text]="T.common.save | translate" (clicked)="onSave(navigateToDetailsPage)"></app-button-rectangle>
    </app-modal-footer>
  </ng-container>
</app-modal>

<ng-template #jobPriorityTemplate let-i="index" let-v="value">
  <span class="material-symbols-outlined"
    [ngStyle]="{ color: i < v ? 'var(--wt-black)' : 'var(--wt-grey-light)' }">star</span>
</ng-template>


